import { httpRequest } from "@services/http";

export interface OrgUser {
  profile_id: number;
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  roles: { id: number; name: string }[];
  /** False once the account is deactivated. Roles stay attached on purpose, so
   * this is the only field that says whether the row can still sign in. */
  is_active: boolean;
  /** True when the person's employee record leaves them out of every org their
   * profile names, so they are listed here but missing from every contact
   * picker. Repaired by adding them to this org again. */
  needs_org_repair: boolean;
}

export class CommandListOrgUsers {
  async run(orgId: number): Promise<OrgUser[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/organizations/${orgId}/users/`;
    try {
      return await httpRequest<OrgUser[]>(url, { method: "GET" });
    } catch (error) {
      console.error("Error fetching org users:", error);
      throw error;
    }
  }
}
